export default __webpack_public_path__ + "static/media/Karnataka_Hover.fa1b0c40.svg";